import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz19 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel20'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel18'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article
    class="container">
    <h1 class="title">Poison and Rat</h1>
    
    <div class="text">
        <p>There are 1000 wine bottles. One of the bottles contains poisoned wine. A rat dies after one hour of drinking
            the poisoned wine. How many minimum rats are needed to figure out which bottle contains poison in hour.</p>
        <p><br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </p>
        <div class="containers">
        <p><strong>Solution:</strong><br/>
            We need to figure out in hour. We need 10 rats to figure out the poisoned
            bottle. The result is based on binary number system. We get 10 using ⌈ Log<sub>2</sub>1000 ⌉.</p>
        <p>The idea is to number bottles from 1 to 1000 and write their corresponding binary numbers on the bottle. Each
            rat is assigned a position in the binary numbers written on bottles. Let us take an example. Rat 1
            represents first bit in every bottle, rat 2 represents second bit and so on. If rat numbers 5, 7 and 9 die,
            then bottle number 42 (Binary 0000101010) is poisoned.</p>
        </div>
       
    </div>
</article>
        </div>
    )
}

export default Puz19
